import { cn } from "@/lib/cn";
import { ScreenRecordingClipCard } from "./screen-recording-clip-card";
import { useScreenRecordingStore } from "./screen-recording-store";

export function ScreenRecordingDraft({
  sessionId,
  status = false,
  showVideo = true,
}: {
  sessionId?: string;
  status?: boolean;
  showVideo?: boolean;
} = {}) {
  const clips = useScreenRecordingStore((state) => state.clips);
  const sessions = useScreenRecordingStore((state) => state.sessions);
  const recordings = Object.values(clips).filter((clip) =>
    sessionId
      ? clip.attentionSessionId === sessionId &&
        sessions[clip.attentionSessionId] === "voice"
      : sessions[clip.attentionSessionId] === "text",
  );
  if (sessionId)
    recordings.sort((first, second) => first.startedMs - second.startedMs);
  if (recordings.length === 0) return null;
  return (
    <div
      className={cn(
        "flex flex-wrap gap-1 px-2 py-1",
        status && "justify-center",
      )}
      data-testid="screen-recording-draft"
    >
      {recordings.map((clip, index) => (
        <ScreenRecordingClipCard
          key={clip.clipId}
          clip={clip}
          number={index + 1}
          status={status}
          showVideo={showVideo}
        />
      ))}
    </div>
  );
}
